// ─── Protección del documento abierto ────────────────────────────────────────
// Un documento que se está escribiendo vive SOLO en memoria (state.editingDoc).
// No está en localStorage, no viaja a la nube y tampoco aparece en "documentos
// a medias": esa lista se arma con los borradores YA guardados.
//
// Es decir: recargar con el formulario abierto borra todo lo escrito, sin
// rastro. Pasaba al pulsar "Actualizar ahora" en el aviso de versión nueva
// —que además prometía lo contrario— y también con un F5 o al cerrar la
// pestaña por accidente.
//
// Aquí vive el aviso que lo impide. No guarda por su cuenta: el guardado tiene
// validaciones propias (cliente, tiempo de entrega, contacto…) y forzarlo
// crearía documentos a medio llenar. Lo que hace es no dejar que el trabajo se
// vaya en silencio.
import { state } from "../core/state.js";
import { parseNumber } from "../core/utils.js";

let salidaPermitida = false;

// ¿Hay un documento abierto con algo que perder? Un formulario recién abierto
// y todavía vacío no cuenta: avisar ahí sería puro estorbo.
export function hayDocumentoAbierto() {
  const d = state.editingDoc;
  if (!d) return false;
  const items = d.items || [];
  const tieneItems = items.some(it =>
    String(it.articulo || "").trim() ||
    String(it.descripcion || "").trim() ||
    parseNumber(it.cantidad) > 0 ||
    parseNumber(it.precio_unitario) > 0);
  return !!(d.cliente_id || d._clienteLibre || d.proveedor_id ||
            String(d.notas || "").trim() || tieneItems);
}

// Permite la próxima salida sin preguntar (para una recarga que el usuario ya
// confirmó a sabiendas).
export function permitirSalida() {
  salidaPermitida = true;
}

// Red de seguridad del navegador: cubre F5, cerrar la pestaña y cualquier otra
// salida que no pase por el aviso de versión.
export function vigilarSalida() {
  window.addEventListener("beforeunload", (e) => {
    if (salidaPermitida || !hayDocumentoAbierto()) return;
    e.preventDefault();
    e.returnValue = "";   // el navegador muestra su propia confirmación
  });
}
